import styled from "styled-components";
import { Card, Typography } from "antd";
const { Title } = Typography;

export const LoginContainerSC = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

export const StyledCardSC = styled(Card)`
    width: 400px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
`;

export const LoginTitleSC = styled(Title)`
    text-align: center;
    margin-bottom: 24px !important;
    color: #1890ff;
`;
